/* global window */

"use strict";

import $ from 'jquery';
import _ from 'underscore';

var Templates = new Map();
var requireContext = require.context('../template-js/', false, new RegExp(
  "(" +
    "address-row|" +
    "event-box|" +
    "event-search|" +
    "org-box|" +
    "org-search|" +
    "tag-li|" +
    "visibility-bar|" +
    "visibility-search-input" +
    ")\.html$"
));
requireContext.keys().forEach((relPath) => {
  var name = relPath.replace(/^\.\/(.*\.html)$/, "$1");
  Templates[name] = requireContext(relPath);
});

var t = {

  _functionCache: {},

  process: function (name, f, data, options) {
    _.extend(data || {}, {
      templator: t,
    });

    try {
      var html = f(data);
    } catch (error) {
      console.error("Template function error: " + name);
      throw error.stack;
    }

    html = html.trim();

    if (options && _.has(options, "compact") && options.compact) {
      html = html.replace(/>\s+/gm, ">");
      html = html.replace(/\s+</gm, "<");
    }

    return html;
  },

  render: function (name, data, options) {
    var f = t._functionCache[name];
    if (!f) {
      var module = Templates[name];
      if (!module) {
        throw new Error("Template `" + name + "` has not been required in `template.js`.");
      }
      f = _.template(module.default);
      t._functionCache[name] = f;
    }

    var html = t.process(name, f, data, options);
    return html;
  }
};

var templator = t;

export {
  templator,
};
